// Modals available on all screens.
// These are registered globally in src/vue/components.js
const MODAL_NAMES = {
    ACTION_SHEET: 'ActionSheetModal',
    ALERT: 'AlertModal',
    CONFIRM: 'ConfirmModal',
    CUSTOM_CONFIRM: 'CustomConfirmModal',
    LOGIN_SETTINGS: 'LoginSettingsModal',
    NUM_PAD: 'NumPadModal',
    ONLINE_STATUS: 'OfflineStatus',
    PHOTO_SELECTOR: 'PhotoSelectorModal',
    PIN_REQUEST: 'PinRequestModal',
    PROMPT: 'PromptModal',
    PROPOINT_UPDATE: 'ProPointUpdateModal',
    SWITCH_USER: 'SwitchUserModal',
    TIME_ERROR: 'TimeErrorModal',
    TIMEZONE_ERROR: 'TimezoneErrorModal',
};

module.exports = {
    MODAL_NAMES,
};
